var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _g30, _g31, _g32, _g33, _g34, _g35, _g36, _g37, _g38, _g39, _g40, _g41, _g42, _g43;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCopy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    width: "800px",
    height: "800px",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-896,-320)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Icons",
    x: 0,
    y: 0,
    width: 1280,
    height: 800,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icons1"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Strike"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "H1"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "H2"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "H3"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "list-ul"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "hamburger-1"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "hamburger-2"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "list-ol"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "list-task"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "trash"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "vertical-menu"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "horizontal-menu"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "sidebar-2"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Pen"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "Pen1"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "clock"
  })), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "external-link"
  })), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "hr"
  })), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "info"
  })), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "warning"
  })), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "plus-circle"
  })), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "minus-circle"
  })), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "vue"
  })), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    id: "cog"
  })), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    id: "logo"
  })), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    id: "radio-check"
  })), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    id: "eye-slash"
  })), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    id: "eye"
  })), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    id: "toggle-off"
  })), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    id: "shredder"
  })), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    id: "spinner--loading--dots-"
  })), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    id: "react"
  })), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    id: "check-selected"
  })), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    id: "turn-off"
  })), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    id: "code-block"
  })), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    id: "user"
  })), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    id: "coffee-bean"
  })), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.638317,0.368532,-0.368532,0.638317,785.021,-208.975)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "coffee-beans"
  }, /*#__PURE__*/React.createElement("g", {
    id: "coffee-bean1"
  })))), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    id: "coffee-bean-filled"
  })), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.638317,0.368532,-0.368532,0.638317,913.062,-208.975)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "coffee-beans-filled"
  }, /*#__PURE__*/React.createElement("g", {
    id: "coffee-bean2"
  })))), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    id: "clipboard"
  })), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,128.011,1.35415)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "clipboard-paste"
  }))), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    id: "clipboard-copy"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer1",
    transform: "matrix(1,0,0,1,-128,0.0182636)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.10208,0,0,1.49634,241.952,-180.793)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.05089,0,0,1,348.221,82.8722)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 189.816,
    y: 267,
    width: 8.226,
    height: 2,
    style: {
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.05089,0,0,1,348.206,88.1161)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 189.816,
    y: 267,
    width: 8.226,
    height: 2,
    style: {
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.05089,0,0,1,348.221,93.3599)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 189.816,
    y: 267,
    width: 8.226,
    height: 2,
    style: {
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.05089,0,0,1,348.221,98.6037)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 189.816,
    y: 267,
    width: 8.226,
    height: 2,
    style: {
      fillRule: "nonzero"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.372314,0,0,1.49634,765.419,-187.527)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.05089,0,0,1,348.221,82.8722)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 189.816,
    y: 267,
    width: 8.226,
    height: 2,
    style: {
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.05089,0,0,1,348.206,88.1161)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 189.816,
    y: 267,
    width: 8.226,
    height: 2,
    style: {
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.05089,0,0,1,348.221,93.3599)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 189.816,
    y: 267,
    width: 8.226,
    height: 2,
    style: {
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.05089,0,0,1,348.221,98.6037)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 189.816,
    y: 267,
    width: 8.226,
    height: 2,
    style: {
      fillRule: "nonzero"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,138,7.98174)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M938.222,331.852L913.778,331.852L913.778,364.167L938.222,364.167L938.222,331.852ZM942,368L910,368L910,328.018L942,328.018L942,368Z",
    style: {
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1064,334.388L1060.22,334.388L1060.22,331.833L1035.78,331.833L1035.78,364.148L1046.41,364.148L1046.41,367.982L1032,367.982L1032,328L1064,328L1064,334.388Z",
    style: {
      fillRule: "nonzero"
    }
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.00a8f46a4ae48f20e9d133bb3bbf3684.svg";
export { ForwardRef as ReactComponent };